import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export const Contact = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success', 'error', or null

  const clearState = () => {
    setStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    const formData = new FormData(e.target);
    const userName = formData.get('from_name');
    const userEmail = formData.get('from_email');
    const message = formData.get('message');

    try {
      // Check if keys are missing
      if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
        console.warn("⚠️ EmailJS keys are missing! Check .env file.");
        throw new Error("EmailJS keys are missing");
      }

      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name: userName,
          from_email: userEmail,
          message: `Name: ${userName}\nEmail: ${userEmail}\n\nMessage:\n${message}`,
          reply_to: userEmail
        },
        PUBLIC_KEY
      );

      setStatus('success');
      e.target.reset();
    } catch (error) {
      console.error('EmailJS Error:', error);
      setStatus('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                {status !== 'success' && (
                  <p>
                    Please fill out the form below to send us an email and we will
                    get back to you as soon as possible.
                  </p>
                )}
              </div>
              {status === 'error' && (
                <div className="alert alert-danger">
                  Something went wrong. Please try again later.
                </div>
              )}
              {status !== 'success' ? (
                <form name="sentMessage" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="from_name"
                          name="from_name"
                          className="form-control"
                          placeholder="Name"
                          required
                          disabled={isLoading}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="from_email"
                          name="from_email"
                          className="form-control"
                          placeholder="Email"
                          required
                          disabled={isLoading}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      disabled={isLoading}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button
                    type="submit"
                    className="btn btn-custom btn-lg"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              ) : (
                <div className="success-message">
                  <h3>Your message has been successfully received. Our team will respond to you as soon as possible.</h3>
                  <button onClick={clearState} className="btn btn-custom btn-lg">
                    Send Another Message
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 Nextgen Codeworks. All rights reserved.{" "}
            <a href="https://www.nextgencodeworks.com" rel="nofollow">
              Nextgen Codeworks
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};